<template>
    <v-main v-resize="onResize">
        <v-data-table
            :headers="commonDataHeaders"
            :items="commonData"
            코드="searccodeext"
            옵션명-by="id"
            :items-per-page="itemsPerPageInt"
            class="elevation-3 pa-0 mx-3"
            dense
            locale="kr-KR"
            no-data-text="데이터가가 없습니다."
            no-results-text="검색 결과가 없습니다."
            :footer-props="{
                itemsPerPageText: '페이지당 옵션 수',
                itemsPerPageAllText: '전체',
                itemsPerPageAll: '전체',
                itemsPerPageOptions: [2, 10, 25, 50, 100, -1],
            }">
            <template v-slot:top>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            v-model="editedItem.name"
                                            label="옵션명"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            v-model="editedItem.value"
                                            label="값"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-text-field
                                            v-model="editedItem.priority"
                                            label="정렬순서"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="save">저장</v-btn>
                            <v-btn color="blue darken-1" text @click="close">닫기</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-row class="mt-n16">
                    <v-col cols="12" sm="6" class="mb-n8">
                    <h2 class="ml-4 mb-7">
                        <v-icon>mdi-cards-playing-outline</v-icon> {{ selectedCode.name }} 목록
                    </h2>
                    </v-col>
                    <v-col cols="12" sm="6" v-if="false">
                        <v-card-title>
                            <v-text-field
                            v-model="searchText"
                            append-icon="mdi-magnify"
                            label="검색"
                            single-line
                            hide-details>
                            </v-text-field>
                        </v-card-title>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
                <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </template>
            <template v-slot:no-data />
        </v-data-table>
    </v-main>
</template>

<script>
import axios from "axios";

export default {
    props: {
        category: {},
        selectedCode: {},
    },
    data: () => ({
        t: true,
        f: false,
        dialog: false,
        commonDataHeaders: [
            { text: "타이틀", value: "name" },
            { text: "값", value: "value" },
            { text: "정렬순서", value: "priority" },
            { text: "작업", value: "actions", sortable: false },
        ],
        commonData: [],
        editedIndex: -1,
        editedItem: {
            name: "",
            value: "",
            priority: "",
            uniqueId: "",
        },
        defaultItem: {
            name: "",
            value: "",
            priority: "",
            commonUniqueId: "",
        },
        itemsPerPage: 25,
        searchText: "",
    }),

    computed: {
        itemsPerPageInt() {
            return parseInt(this.itemsPerPage);
        },
        formTitle() {
            return this.editedIndex === -1 ? "옵션 등록" : "옵션 수정";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        selectedCode(codeObject) {
            console.log("바껴버림 : " + codeObject)
            if(codeObject != null){
                this.getCommonData()
            }
        }
    },

    created() {
        console.log(this.selectedCode)
        if(this.selectedCode && this.selectedCode.code != null){
            this.getCommonData()
        }
    },

    mounted() {
        this.onResize();
    },

  methods: {
    editItem(item) {
      this.editedIndex = this.commonData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async deleteItem(item) {
      if (confirm("삭제 시 다시 되돌릴 수 없습니다.\n정말 삭제하시겠습니까?")) {
        if (await this.deleteCommonData(item.id)) {
          const index = this.commonData.indexOf(item);
          this.commonData.splice(index, 1);
        }
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.saveCommonData()) {
        if (this.editedIndex > -1) {
          Object.assign(this.commonData[this.editedIndex], this.editedItem);
        } else {
          this.commonData.push(this.editedItem);
        }

        this.close();
      }
    },

    getCommonData: function () {
        let additional = ''
        if(this.selectedCode.code == 'paper1' || this.selectedCode.code == 'paper2'){
            additional = '?category=' + this.category
        }
        console.log(this.selectedCode)
        return axios({
            method: "GET",
            headers: {
                Authorization: "bearer " + this.$store.getters.getAccessToken,
            },
            url:
                this.$store.getters.getApiUrl +
                "/api/v1/setting/commonData/getList/" + this.selectedCode.code + additional,
            timeout: this.$store.getters.getApiRequestTimeLimit,
        })
        .then((response) => {
            console.log("CommonDataTable:getCommonData");
            console.log(response.data);
            if (response.data != null && !response.data.status != "9999") {
            this.commonData = response.data.data;
            } else {
            alert(response.data.message);
            return false;
            }
        })
        .catch((error) => {
            if (error && error.name == "InvalidJwtToken") {
            //JWT 토큰이 정확하지 않을 시
            alert("인증 토큰이 유효하지 않습니다.");
            return false;
            } else {
            //저장 실패 시
            alert("데이터 로딩에 실패했습니다.");
            }
        });
    },

    saveCommonData: function () {
        return axios({
            method: "POST",
            headers: {
                Authorization: "bearer " + this.$store.getters.getAccessToken,
            },
            url:
                this.$store.getters.getApiUrl +
                "/api/v1/setting/commonData/save/",
            data: this.editedItem,
            timeout: this.$store.getters.getApiRequestTimeLimit,
            })
            .then((response) => {
                if (response.data != null && response.data.status != "9999") {
                alert(response.data.message);
                this.editedItem = this.defaultItem;
                } else {
                alert(response.data.message);
                return false;
                }
            })
            .catch((error) => {
                if (error && error.name == "InvalidJwtToken") {
                    //JWT 토큰이 정확하지 않을 시
                    alert("인증 토큰이 유효하지 않습니다.");
                    return false;
                } else {
                    //저장 실패 시
                    alert("저장에 실패했습니다.\n다시 시도해주세요.");
                    return false;
                }   
        });
    },

    deleteCommonData: function (id) {
      if (!id) {
        alert("옵션 고유번호가 누락되었습니다\n개발자에게 문의하세요.");
        return false;
      }

      return axios({
        method: "POST",
        headers: {
          Authorization: "bearer " + this.$store.getters.getAccessToken,
        },
        url:
          this.$store.getters.getApiUrl +
          "/api/v1/setting/commonData/delete/" + id,
        timeout: this.$store.getters.getApiRequestTimeLimit,
      })
        .then((response) => {
            if (response.data != null && response.data.status == "0000") {
                alert(response.data.message);
                return true;
            } else {
                alert(response.data.message);
                return false;
            }
        })
        .catch((error) => {
          if (error && error.name == "InvalidJwtToken") {
            //JWT 토큰이 정확하지 않을 시
            alert("인증 토큰이 유효하지 않습니다.");
            return false;
          } else {
            //저장 실패 시
            alert("삭제에 실패했습니다.\n다시 시도해주세요.");
            return false;
          }
        });
    },

    onResize: function () {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          this.itemsPerPage = "2";
          break;
        case "sm":
          this.itemsPerPage = "10";
          break;
        case "md":
        case "lg":
        case "xl":
          this.itemsPerPage = "25";
          break;
        default:
          this.itemsPerPage = "25";
      }
    },
  },
};
</script>